import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Modal from './Modal';

import stylesLosslessSupportModal from './LosslessSupportModal.css';
import * as uiActions from '../../actions/ui';

import classnames from 'classnames';
import DownloadAppButton from '../util/DownloadAppButton';
import { selectOpenModalTypeIs } from '../../selectors/modals';
import { selectClientDeviceClass } from '../../selectors/client';

class LosslessSupportModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    clientDeviceClass: PropTypes.string.isRequired,
  };

  render() {
    const { hideModal, isOpen } = this.props;

    const downloadButtonClasses = classnames(
      'c-btn',
      'c-btn--is-purple',
      stylesLosslessSupportModal.downloadLink
    );

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={hideModal}
        onClose={hideModal}
        contentLabel="lossless-support-modal"
      >
        <section className={stylesLosslessSupportModal.modal}>
          <p>
            {this.props.clientDeviceClass === 'computer' ? (
              <FormattedMessage
                id="account.audio-quality.browser-support-notice"
                defaultMessage="Your browser currently doesn’t support lossless playback, but we are working on a solution. In the meantime, please use Google Chrome or download our app for the best IDAGIO experience."
              />
            ) : (
              <FormattedMessage
                id="account.audio-quality.browser-support-notice.phone"
                defaultMessage="Your browser currently doesn’t support lossless playback, but we are working on a solution. In the meantime, please download our app for the best IDAGIO experience."
              />
            )}
          </p>
          <DownloadAppButton page="LosslessSupportModal" className={downloadButtonClasses} />
          <p>
            <button className="c-text-link--is-visible" onClick={hideModal}>
              <FormattedMessage
                id="account.audio-quality.browser-support-notice.maybeLater"
                defaultMessage="Maybe later"
              />
            </button>
          </p>
        </section>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: selectOpenModalTypeIs(state, 'LOSSLESS_SUPPORT_MODAL'),
    clientDeviceClass: selectClientDeviceClass(state),
  };
}

export default connect(mapStateToProps, {
  hideModal: uiActions.hideModal,
})(LosslessSupportModal);
